module.exports = __webpack_public_path__ + "static/media/atletico-mg.c2f4a6c7.svg";